import axios from "axios";
import { toast } from "react-toastify";
import configFile from "../config.js";
import localStorageService from "./http.localStorage";
import authService from "./auth.service";

const http = axios.create({
  baseURL: configFile.apiEndpoint,
});

http.interceptors.request.use(
  async function (config) {
    const expiresDate = localStorageService.getTokenExpiresDate();
    const refreshToken = localStorageService.getRefreshToken();
    const isExpired = refreshToken && expiresDate < Date.now();

    const currentCountry = localStorage.getItem("userCountry");

    if (configFile.isFireBase) {
      const containSlash = /\/$/gi.test(config.url);
      config.url =
        (containSlash ? config.url.slice(0, -1) : config.url) + ".json";
      if (isExpired) {
        try {
          const data = await authService.refresh();
          localStorageService.setTokens({
            refreshToken: data.refresh_token,
            accessToken: data.id_token,
            expiresIn: data.expires_id,
            userId: data.user_id,
            groupId: data.groupId,
          });
        } catch (error) {
          console.error("Ошибка обновления токена (Firebase):", error);
          localStorageService.removeAuthData();
          window.location.href = "/";
          return Promise.reject(error);
        }
      }
      const accessToken = localStorageService.getAccessToken();
      if (accessToken) {
        config.params = { ...config.params, auth: accessToken };
      }

      // Add country information (except for country requests)

      if (
        currentCountry &&
        !config.url.includes("country") &&
        !config.url.includes("submit")
      ) {
        // Для GET запросов добавляем в параметры
        if (config.method === "get" || config.method === "delete") {
          config.params = {
            ...config.params,
            country: currentCountry,
          };
        }

        // Добавляем заголовок
        config.headers = {
          ...config.headers,
          "X-Country-Code": currentCountry,
        };

        // Для POST/PUT/PATCH добавляем в тело запроса
        if (["post", "put", "patch"].includes(config.method) && config.data) {
          if (
            typeof config.data === "object" &&
            !(config.data instanceof FormData)
          ) {
            config.data = {
              ...config.data,
              country: currentCountry,
            };
          }
        }
      }

      return config;
    } else {
      if (isExpired) {
        try {
          const data = await authService.refresh();
          localStorageService.setTokens(data); // обновляем токены
        } catch (error) {
          console.error("❌ Ошибка при обновлении токена:", error);
          // токен невалидный — очищаем localStorage
          localStorageService.removeAuthData();
          // (опционально) редирект на логин
          window.location.href = "/";
          return Promise.reject(error);
        }
      }
      const accessToken = localStorageService.getAccessToken();
      if (accessToken) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        };
      }
      // Добавляем информацию о стране (кроме запросов к самому country)
      if (
        currentCountry &&
        !config.url.includes("country") &&
        !config.url.includes("submit")
      ) {
        // Для GET запросов добавляем в параметры
        if (config.method === "get" || config.method === "delete") {
          config.params = {
            ...config.params,
            country: currentCountry,
          };
        }

        // Добавляем заголовок
        config.headers = {
          ...config.headers,
          "x-country-code": currentCountry,
        };

        // Для POST/PUT/PATCH добавляем в тело запроса
        if (["post", "put", "patch"].includes(config.method) && config.data) {
          if (
            typeof config.data === "object" &&
            !(config.data instanceof FormData)
          ) {
            config.data = {
              ...config.data,
              country: currentCountry,
            };
          }
        }
      }
    }
    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

function transformData(data) {
  return data && !data._id
    ? Object.keys(data).map((key) => ({
        ...data[key],
      }))
    : data;
}

http.interceptors.response.use(
  (res) => {
    if (configFile.isFirebase) {
      res.data = { content: transformData(res.data) };
    }
    return res;
  },
  function (error) {
    // 🔒 Если токен недействителен — разлогиниваем
    if (error.response?.status === 401) {
      localStorageService.removeAuthData();
      window.location.href = "/";
      return Promise.reject(error);
    }

    const expectedErrors =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedErrors) {
      console.log(error);
      toast.error("Something was wrong. Try it later");
    }
    return Promise.reject(error);
  }
);

const httpService = {
  get: http.get,
  post: http.post,
  put: http.put,
  delete: http.delete,
  patch: http.patch,
};

// Auto-initialize on import
// countryService.initialize();

export default httpService;
